// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1pu--","selects":"Documents_selects__2P2Pb"};